var map = {
	"./account-icons/phone.svg": "a309",
	"./account-user.svg": "5ba3",
	"./adress.svg": "896a",
	"./animation/LoaderRadius.svg": "9a1d",
	"./animation/Pulse.svg": "8ca5",
	"./arrow-double-gray.svg": "c2d8",
	"./arrow-hover.svg": "af70",
	"./arrow.svg": "315f",
	"./attention-icon.svg": "1d17",
	"./barcode.svg": "c40c",
	"./bell-colorless.svg": "e0a7",
	"./bell.svg": "4bf1",
	"./billing_notfound.svg": "f237",
	"./blog_not-found.svg": "1010",
	"./bookmark-fill.svg": "0849",
	"./bookmark.svg": "bf7c",
	"./card.svg": "cb16",
	"./charts.svg": "59b9",
	"./chat-account.svg": "8f1a",
	"./chat.svg": "315c",
	"./check-outline.svg": "24a3",
	"./check-white.svg": "e4fd",
	"./check.svg": "6561",
	"./chevrons-right.svg": "9f10",
	"./clipboard-two-papers.svg": "ab1d",
	"./clipboard.svg": "fe3c",
	"./clock-icon.svg": "ef3b",
	"./clock.svg": "40ce",
	"./close-button.svg": "7693",
	"./close.svg": "58a4",
	"./credit-card.svg": "982a",
	"./cross-hover.svg": "1fc0",
	"./cross.svg": "4860",
	"./default-avatar.svg": "f75f",
	"./delete.svg": "4edd",
	"./doc_empty.svg": "4893",
	"./document.svg": "23d2",
	"./dollar-sign.svg": "c36d",
	"./dollar.svg": "c749",
	"./download-hover.svg": "0025",
	"./download.svg": "22b4",
	"./edit-pen-account.svg": "d48d",
	"./edit-pen.svg": "a241",
	"./ellipsis.svg": "6fd8",
	"./favorites.svg": "cb7f",
	"./file-text.svg": "0e0f",
	"./file.svg": "15ca",
	"./filter.svg": "a1d2",
	"./flag.svg": "f1bf",
	"./globe.svg": "a8c3",
	"./help-circle.svg": "1491",
	"./helpcenter-sidebar.svg": "c394",
	"./icon-extension.svg": "a543",
	"./info.svg": "7c81",
	"./information.svg": "9d9f",
	"./list.svg": "998d",
	"./log-out.svg": "fb43",
	"./logout.svg": "8668",
	"./mail--white.svg": "53c0",
	"./mail.svg": "0cc2",
	"./message-square.svg": "d3c9",
	"./minus-square.svg": "612c",
	"./next.svg": "95b9",
	"./not-found__bookmarks.svg": "ddbf",
	"./notif_credit.svg": "89f2",
	"./notification/create-revision.svg": "ea22",
	"./notification/new-file.svg": "9727",
	"./notification/new-message.svg": "5cbe",
	"./notification/new-ticket-reply.svg": "951c",
	"./notification/orderid-assigned.svg": "19bb",
	"./order-charts.svg": "a302",
	"./order-id.svg": "3ae9",
	"./order-massages.svg": "2e51",
	"./order-message-free-status.svg": "9eb3",
	"./order-message.svg": "7d9c",
	"./order-page-free-status.svg": "65e2",
	"./order-page.svg": "852c",
	"./order-slides.svg": "9104",
	"./order-ticket-free-status.svg": "8f32",
	"./order-ticket.svg": "f81f",
	"./paperclip.svg": "0d20",
	"./pencil-line.svg": "afc7",
	"./phone.svg": "7b69",
	"./phone_icon.svg": "54e6",
	"./printer.svg": "e3cc",
	"./privacy.svg": "3247",
	"./problem.svg": "3cbf",
	"./rate.svg": "c53b",
	"./reply.svg": "2b76",
	"./revision.svg": "c798",
	"./satefy/mastercard.svg": "219b",
	"./satefy/mcafee.svg": "334d",
	"./satefy/pay-pal-verified.svg": "a5bb",
	"./satefy/site-lock.svg": "f676",
	"./satefy/visa.svg": "310f",
	"./search.svg": "c6a2",
	"./settings.svg": "53df",
	"./slides.svg": "60de",
	"./star-avarage-blue.svg": "3d36",
	"./star-avarage.svg": "1e81",
	"./star-basic.svg": "ed12",
	"./star-complete.svg": "c220",
	"./star-filled-green.svg": "09d1",
	"./star-filled-grey.svg": "86d4",
	"./star-filled-red.svg": "08ec",
	"./star-filled-yellow.svg": "1087",
	"./star-filled.svg": "83b3",
	"./star-transparent.svg": "b4cb",
	"./star-unsatisfactory.svg": "7451",
	"./star.svg": "3c2e",
	"./supermarket.svg": "7079",
	"./support.svg": "02cf",
	"./terms.svg": "a445",
	"./ticket_notif.svg": "6bd5",
	"./trash.svg": "47b8",
	"./trusted.svg": "c8eb",
	"./upload.svg": "5474",
	"./user_account.svg": "919f",
	"./users.svg": "50fd",
	"./withard-finish.svg": "e1b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f350";